// extracted by mini-css-extract-plugin
export var text = "_9z-0";